import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ title, description, keywords, image, url }) => {
    const siteTitle = 'Seltz | Premium Vodka Soda';
    const fullTitle = title ? `${title} | ${siteTitle}` : siteTitle;
    const defaultDescription = 'Descoperă Seltz, băutura răcoritoare premium cu vodka, 4.5% alcool și arome naturale de fructe. 0 zahăr, puține calorii.';
    const defaultKeywords = 'seltz, seltzer, hard seltzer, vodka soda, bautura acidulata cu alcool, bautura 0 zahar, seltz romania';
    const defaultImage = 'https://seltz.eu/assets/images/logo.png'; // Using a placeholder for absolute URL

    return (
        <Helmet htmlAttributes={{ lang: 'ro' }}>
            {/* Standard Metadata */}
            <title>{fullTitle}</title>
            <meta name="description" content={description || defaultDescription} />
            <meta name="keywords" content={keywords || defaultKeywords} />

            {/* Open Graph / Facebook */}
            <meta property="og:type" content="website" />
            <meta property="og:url" content={url || 'https://seltz.eu'} />
            <meta property="og:title" content={fullTitle} />
            <meta property="og:description" content={description || defaultDescription} />
            <meta property="og:image" content={image || defaultImage} />

            {/* Twitter */}
            <meta property="twitter:card" content="summary_large_image" />
            <meta property="twitter:url" content={url || 'https://seltz.eu'} />
            <meta property="twitter:title" content={fullTitle} />
            <meta property="twitter:description" content={description || defaultDescription} />
            <meta property="twitter:image" content={image || defaultImage} />

            {/* Language / Alternate */}
            <link rel="canonical" href={url || 'https://seltz.eu'} />
        </Helmet>
    );
};

export default SEO;
